export * from './useStatic';
